import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { get } from '../../nucleo/api';

/** A chave da contagem: começa com a da lista de atividades, então concluir, adiar ou editar uma tarefa também a renova. */
export const CHAVE_ATRASADAS = ['/pipeline/atividades', 'atrasadas-contagem'] as const;

/**
 * Lote crm5 (X2): a bolinha vermelha no item Atividades da barra lateral quando quem está na sessão tem tarefa atrasada
 * (pendente com o prazo vencido, como responsável ou atribuído). A contagem vem do servidor (leve, sob a RLS), com cache
 * curto; zero ou erro não mostra nada. O número vai no nome acessível e no title.
 */
export function SeloAtrasadas({ compacto }: { compacto?: boolean }) {
  const { t } = useTranslation('pipeline');
  const q = useQuery({
    queryKey: CHAVE_ATRASADAS,
    queryFn: () => get<{ total: number }>('/pipeline/atividades/atrasadas/contagem'),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
  const n = q.data?.total ?? 0;
  if (!n) return null;
  const rotulo = t('atividades.seloMenu', { count: n });
  return <span role="img" aria-label={rotulo} title={rotulo} data-selo-atrasadas={n} className={`size-2.5 shrink-0 rounded-full bg-perigo ${compacto ? 'absolute top-2.5 right-3' : ''}`} />;
}
